export default "__VITE_ASSET__k1t8Y3_Y__"